import { BrowserRouter, NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './App.css';

const navPages = [
  { title: 'Home', path: '/' },
  { title: 'History', path: '/history' },
  { title: 'Things To Do', path: '/things-to-do' },
  { title: 'Neighbourhoods', path: '/neighbourhood' },
  { title: 'Travel', path: '/travel' },
  { title: 'Eat & Drink', path: '/eat-drink' },
  { title: 'Shopping', path: '/shopping' },
  { title: 'Events', path: '/events' },
  { title: 'Contact', path: '/contact' },
  { title: 'Customer', path: '/customer' },
  { title: 'Vendor', path: '/vendor' }
];

const sliderItems = [
  {
    title: 'Amaravati Riverfront Trails',
    text: 'Sunrise walks, heritage stories, and guided boating around Krishna river views.',
    video: 'https://cdn.pixabay.com/video/2019/10/30/28151-370242138_large.mp4',
    poster: 'https://images.unsplash.com/photo-1472396961693-142e6e269027?auto=format&fit=crop&w=1600&q=80'
  },
  {
    title: 'Araku Valley Escape',
    text: 'Coffee estates, tribal culture, caves, and hill-side rail journeys in one package.',
    video: 'https://cdn.pixabay.com/video/2022/10/13/134716-760910342_large.mp4',
    poster: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1600&q=80'
  },
  {
    title: 'Tirupati Pilgrim Circuit',
    text: 'Temple darshan planning with transport, food, and stay recommendations.',
    video: 'https://cdn.pixabay.com/video/2023/06/24/168766-839735705_large.mp4',
    poster: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&w=1600&q=80'
  }
];

const categoryItems = [
  {
    title: 'Temple Tours',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/A%20View%20of%20Tirumala%20Venkateswara%20Temple.JPG'
  },
  {
    title: 'Wildlife',
    image: 'https://images.unsplash.com/photo-1472396961693-142e6e269027?auto=format&fit=crop&w=1200&q=80'
  },
  {
    title: 'Heritage Walks',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Lepakshi%20Temple%2C%20Near%20Hindupur%2C%20Andhra%20Pradesh.JPG'
  },
  {
    title: 'Beaches',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200&q=80'
  },
  {
    title: 'Hill Trails',
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1200&q=80'
  }
];

const destinationItems = [
  {
    name: 'Amaravati',
    detail: 'Ancient Buddhist heritage, modern capital region landmarks.',
    image: 'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?auto=format&fit=crop&w=1200&q=80'
  },
  {
    name: 'Araku Valley',
    detail: 'Scenic hills, coffee plantations, and tribal museums.',
    image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=1200&q=80'
  },
  {
    name: 'Visakhapatnam',
    detail: 'Beachfront city life, submarine museum, and hill viewpoints.',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200&q=80'
  },
  {
    name: 'Lepakshi',
    detail: 'Historic temple art, hanging pillar, and cultural storytelling.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Lepakshi%20Temple%2C%20Near%20Hindupur%2C%20Andhra%20Pradesh.JPG'
  },
  {
    name: 'Papikondalu',
    detail: 'River cruises, forest landscapes, and eco-tour experiences.',
    image: 'https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1200&q=80'
  },
  {
    name: 'Srisailam Route',
    detail: 'Pilgrim routes, hill roads, and temple-town stays.',
    image: 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1200&q=80'
  }
];

const templeItems = [
  {
    name: 'Sri Venkateswara Temple, Tirumala',
    description: 'One of India’s most visited pilgrimage destinations, known for sacred rituals and hilltop darshan.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/A%20View%20of%20Tirumala%20Venkateswara%20Temple.JPG'
  },
  {
    name: 'Kanaka Durga Temple, Vijayawada',
    description: 'A powerful Shakti shrine on Indrakeeladri hill with stunning Krishna river views and festival processions.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Bezawada%20Kanaka%20Durga%20temple.jpg'
  },
  {
    name: 'Srisailam Mallikarjuna Temple',
    description: 'A revered Jyotirlinga and Shakti Peetha destination surrounded by forested hills and spiritual trails.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Mallikarjuna%20Temple%20-%20Srisailam.jpg'
  },
  {
    name: 'Amareswara Temple, Amaravati',
    description: 'Historic Shiva temple in the Krishna river basin, closely tied to Amaravati’s cultural and religious roots.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Amaravathi%20Amareswara%20Swami%20Temple.jpg'
  },
  {
    name: 'Simhachalam Temple, Visakhapatnam',
    description: 'A famous hill temple blending Chola and Kalinga styles, dedicated to Varaha Narasimha Swamy.',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Varaha%20Lakshmi%20Narasimha%20temple%20in%20Simhachalam.jpg'
  }
];

const neighbourhoodItems = [
  {
    name: 'Benz Circle and MG Road, Vijayawada',
    image: 'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?auto=format&fit=crop&w=1000&q=80'
  },
  {
    name: 'Beach Road and Rushikonda belt, Visakhapatnam',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1000&q=80'
  },
  {
    name: 'Old Town and riverfront pockets, Rajamahendravaram',
    image: 'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?auto=format&fit=crop&w=1000&q=80'
  },
  {
    name: 'Temple quarter and market lanes, Tirupati',
    image: 'https://images.unsplash.com/photo-1533929736458-ca588d08c8be?auto=format&fit=crop&w=1000&q=80'
  }
];

const attractionItems = [
  {
    name: 'Undavalli Caves',
    image: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1000&q=80'
  },
  {
    name: 'Borra Caves',
    image: 'https://images.unsplash.com/photo-1465447142348-e9952c393450?auto=format&fit=crop&w=1000&q=80'
  },
  {
    name: 'Belum Caves',
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Bezawada%20Kanaka%20Durga%20temple.jpg'
  },
  {
    name: 'Kondapalli Fort',
    image: 'https://images.unsplash.com/photo-1539650116574-8efeb43e2750?auto=format&fit=crop&w=1000&q=80'
  },
  {
    name: 'Lambasingi viewpoints',
    image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=1000&q=80'
  },
  {
    name: 'Horsley Hills',
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1000&q=80'
  }
];

const serviceItems = [
  {
    text: 'Food delivery from local restaurants',
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=1000&q=80'
  },
  {
    text: 'Ecommerce storefront for crafts and regional products',
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&w=1000&q=80'
  },
  {
    text: 'Book auto services for local commute',
    image: 'https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=1000&q=80'
  },
  {
    text: 'Cab and bike booking similar to ride-hailing apps',
    image: 'https://images.unsplash.com/photo-1556122071-e404eaedb77f?auto=format&fit=crop&w=1000&q=80'
  },
  {
    text: 'Grocery delivery from nearby stores',
    image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1000&q=80'
  },
  {
    text: 'Hotel and homestay booking',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1000&q=80'
  },
  {
    text: 'Local guide and translator booking',
    image: 'https://images.unsplash.com/photo-1527631746610-bca00a040d60?auto=format&fit=crop&w=1000&q=80'
  },
  {
    text: 'Emergency support with one-tap helpline',
    image: 'https://images.unsplash.com/photo-1584982751601-97dcc096659c?auto=format&fit=crop&w=1000&q=80'
  }
];

const pageContent = {
  history: {
    subtitle: 'Andhra Pradesh history, culture, and spiritual heritage routes',
    heroImage: 'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?auto=format&fit=crop&w=1400&q=80',
    points: [
      { text: 'Timeline-based journeys from Satavahana to modern Andhra development.', image: 'https://images.unsplash.com/photo-1605649487212-47bdab064df7?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Buddhist circuit highlights across Amaravati and nearby archaeological zones.', image: 'https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Temple architecture, inscriptions, and guided storytelling experiences.', image: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Local museum directory with opening hours and tour support links.', image: 'https://images.unsplash.com/photo-1582555172866-f73bb12a2ab3?auto=format&fit=crop&w=1000&q=80' }
    ]
  },
  things: {
    subtitle: 'Activities designed for families, pilgrims, solo travelers, and groups',
    heroImage: 'https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=1400&q=80',
    points: [
      { text: 'Adventure options including trekking, zipline zones, and hill cycling.', image: 'https://images.unsplash.com/photo-1454496522488-7a8e488e8606?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Nature itineraries for waterfalls, forest reserves, and river islands.', image: 'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Weekend plans with nearby attractions and meal stop recommendations.', image: 'https://images.unsplash.com/photo-1530789253388-582c481c54b0?auto=format&fit=crop&w=1000&q=80' },
      { text: 'AI planner to mix interests, duration, and budget in one click.', image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1000&q=80' }
    ]
  },
  neighbourhood: {
    subtitle: 'Explore local areas with smart filters and live map assistance',
    heroImage: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=1400&q=80',
    points: [
      { text: 'Find nearest restaurants, hospitals, pharmacies, and fuel stations.', image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Sort by ratings, distance, budget, and service availability.', image: 'https://images.unsplash.com/photo-1524661135-423995f22d0b?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Discover local events and cultural streets in each city area.', image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Neighborhood safety and emergency contact highlights for tourists.', image: 'https://images.unsplash.com/photo-1461360370896-922624d12aa1?auto=format&fit=crop&w=1000&q=80' }
    ]
  },
  travel: {
    subtitle: 'Plan intercity and intracity travel across Andhra Pradesh',
    heroImage: 'https://images.unsplash.com/photo-1488085061387-422e29b40080?auto=format&fit=crop&w=1400&q=80',
    points: [
      { text: 'Bus, train, car rental, and route suggestions with travel time estimates.', image: 'https://images.unsplash.com/photo-1465447142348-e9952c393450?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Book autos, cabs, and bike rides for local travel in major cities.', image: 'https://images.unsplash.com/photo-1519003722824-194d4455a60c?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Pilgrim transport bundles with return rides and rest-stop options.', image: 'https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Smart trip dashboard with checkpoints, weather, and traffic alerts.', image: 'https://images.unsplash.com/photo-1516738901171-8eb4fc13bd20?auto=format&fit=crop&w=1000&q=80' }
    ]
  },
  eatDrink: {
    subtitle: 'Taste local Andhra cuisine with food services and curated trails',
    heroImage: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?auto=format&fit=crop&w=1400&q=80',
    points: [
      { text: 'Top-rated tiffin, biryani, seafood, and sweet shops by locality.', image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Food delivery integration for hotels, homes, and travel groups.', image: 'https://images.unsplash.com/photo-1526367790999-0150786686a2?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Festival menus and city-wise culinary recommendation lists.', image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Vendor registration for restaurants, cafes, and cloud kitchens.', image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=1000&q=80' }
    ]
  },
  shopping: {
    subtitle: 'Shop local crafts, textiles, gifts, and daily essentials',
    heroImage: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?auto=format&fit=crop&w=1400&q=80',
    points: [
      { text: 'Ecommerce marketplace for handicrafts, Kondapalli toys, and textiles.', image: 'https://images.unsplash.com/photo-1463100099107-aa0980c362e6?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Hyperlocal grocery and essentials delivery by neighborhood stores.', image: 'https://images.unsplash.com/photo-1604719312566-8912e9c8a213?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Festival and wedding shopping guides with map-based listings.', image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Merchant tools for catalog upload, offers, inventory, and delivery status.', image: 'https://images.unsplash.com/photo-1556740738-b6a63e27c4df?auto=format&fit=crop&w=1000&q=80' }
    ]
  },
  events: {
    subtitle: 'City events, temple festivals, concerts, and sports schedules',
    heroImage: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=1400&q=80',
    points: [
      { text: 'Calendar-driven listings with booking, reminders, and attendance tracking.', image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=1000&q=80' },
      { text: 'State festival spotlights and route suggestions for tourists.', image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Event stalls onboarding for food, crafts, and local service vendors.', image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Community notices for marathons, exhibitions, and youth sports events.', image: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?auto=format&fit=crop&w=1000&q=80' }
    ]
  },
  contact: {
    subtitle: 'Support desk for travelers, vendors, and emergency assistance',
    heroImage: 'https://images.unsplash.com/photo-1534531173927-aeb928d54385?auto=format&fit=crop&w=1400&q=80',
    points: [
      { text: 'Tourist helpdesk for itinerary changes, cancellations, and local guidance.', image: 'https://images.unsplash.com/photo-1487611459768-bd414656ea10?auto=format&fit=crop&w=1000&q=80' },
      { text: '24x7 emergency quick links for police, ambulance, and fire services.', image: 'https://images.unsplash.com/photo-1584433144859-1fc3ab64a957?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Vendor onboarding support for KYC, listing approval, and promotions.', image: 'https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Partnership support for hotels, transport operators, and tour agencies.', image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1000&q=80' }
    ]
  },
  customer: {
    subtitle: 'Customer portal for profile, bookings, and local service access',
    heroImage: 'https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1400&q=80',
    points: [
      { text: 'Unified dashboard for trips, tickets, stays, and local transport rides.', image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Manage food orders, grocery delivery, and e-commerce purchases.', image: 'https://images.unsplash.com/photo-1561715276-a2d087060f1d?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Save favorite destinations, temples, and personalized travel plans.', image: 'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Wallet, payment history, refunds, and offer management.', image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1000&q=80' }
    ]
  },
  vendor: {
    subtitle: 'Vendor center for tourism and daily local service businesses',
    heroImage: 'https://images.unsplash.com/photo-1556740714-a8395b3bf30f?auto=format&fit=crop&w=1400&q=80',
    points: [
      { text: 'KYC verification and onboarding for hotels, travel, food, and retail vendors.', image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Create listings with photos, videos, prices, and availability calendars.', image: 'https://images.unsplash.com/photo-1545239351-1141bd82e8a6?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Track orders for food delivery, grocery, ride requests, and bookings.', image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1000&q=80' },
      { text: 'Analytics for sales, customer ratings, commissions, and payouts.', image: 'https://images.unsplash.com/photo-1551281044-8b5bd4d67f35?auto=format&fit=crop&w=1000&q=80' }
    ]
  }
};

const sectionImages = {
  categories: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1400&q=80',
  temples: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=1400&q=80',
  neighbourhoods: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?auto=format&fit=crop&w=1400&q=80',
  attractions: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1400&q=80',
  explore: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1400&q=80',
  services: 'https://images.unsplash.com/photo-1489516408517-0c0a15662682?auto=format&fit=crop&w=1400&q=80'
};

function HomePage() {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((current) => (current + 1) % sliderItems.length);
    }, 3500);

    return () => clearInterval(timer);
  }, []);


  return (
    <div className="stack">
      <div className="slider-container container-fluid">
        <section className="hero hero-video" aria-label="Travel location video slider">
          <video
            key={sliderItems[activeSlide].video}
            className="hero-video-media"
            src={sliderItems[activeSlide].video}
            poster={sliderItems[activeSlide].poster}
            autoPlay
            muted
            loop
            playsInline
          />
          <div className="hero-video-overlay" />
          <div className="hero-video-content">
            <p className="slider-tag">Featured Destination</p>
            <h1>{sliderItems[activeSlide].title}</h1>
            <p>{sliderItems[activeSlide].text}</p>
            <div className="dots" aria-hidden="true">
              {sliderItems.map((item, index) => (
                <span key={item.title} className={index === activeSlide ? 'dot dot-active' : 'dot'} />
              ))}
            </div>
          </div>
        </section>
      </div>

      <section className="panel tour-categories">
        <p className="tour-script">Wonderful Place for You</p>
        <h2>Tour Categories</h2>
        <div className="category-row">
          {categoryItems.map((item) => (
            <article
              key={item.title}
              className="category-card"
            >
              <img src={item.image} alt={item.title} className="category-media" />
              <h3>{item.title}</h3>
              <a href="#/" onClick={(e) => e.preventDefault()}>See More</a>
            </article>
          ))}
        </div>
      </section>

      <section className="panel">
        <h2>Popular Destinations</h2>
        <div className="card-grid">
          {destinationItems.map((item) => (
            <article key={item.name} className="card">
              <img className="card-media" src={item.image} alt={item.name} />
              <h3>{item.name}</h3>
              <p>{item.detail}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="panel">
        <img className="section-banner" src={sectionImages.temples} alt="Temple tourism" />
        <h2>Temple Circuit</h2>
        <div className="card-grid">
          {templeItems.map((item) => (
            <article key={item.name} className="card">
              <img className="card-media" src={item.image} alt={item.name} />
              <h3>{item.name}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="panel two-col">
        <article>
          <img className="section-banner" src={sectionImages.neighbourhoods} alt="Neighbourhoods" />
          <h2>Neighbourhoods</h2>
          <div className="card-grid">
            {neighbourhoodItems.map((item) => (
              <article key={item.name} className="card">
                <img className="card-media" src={item.image} alt={item.name} />
                <p>{item.name}</p>
              </article>
            ))}
          </div>
        </article>
        <article>
          <img className="section-banner" src={sectionImages.attractions} alt="Attractions" />
          <h2>Attractions</h2>
          <div className="card-grid">
            {attractionItems.map((item) => (
              <article key={item.name} className="card">
                <img className="card-media" src={item.image} alt={item.name} />
                <p>{item.name}</p>
              </article>
            ))}
          </div>
        </article>
      </section>

      <section className="panel">
        <img className="section-banner" src={sectionImages.explore} alt="Travel and explore" />
        <h2>Travel and Explore in Andhra Pradesh</h2>
        <p>
          Plan by season, festival calendar, family needs, or spiritual routes. Use smart filters
          for distance, budget, and travel time to build your ideal Andhra trip in minutes.
        </p>
      </section>

      <section className="panel">
        <img className="section-banner" src={sectionImages.services} alt="Local services" />
        <h2>Local Services</h2>
        <div className="card-grid">
          {serviceItems.map((item) => (
            <article key={item.text} className="card service-card">
              <img className="card-media" src={item.image} alt={item.text} />
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

function InfoPage({ title, subtitle, points, heroImage }) {
  return (
    <section className="panel stack-page">
      <img className="page-hero" src={heroImage} alt={title} />
      <p className="eyebrow">Andhra Yatri</p>
      <h1>{title}</h1>
      <p className="subtitle">{subtitle}</p>
      <div className="card-grid">
        {points.map((point) => (
          <article key={point.text} className="card">
            <img className="card-media" src={point.image} alt={title} />
            <p>{point.text}</p>
          </article>
        ))}
      </div>
      <div className="service-strip">
        <h3>Integrated Local Services</h3>
        <p>
          Food delivery, grocery delivery, e-commerce, auto booking, and cab/bike rides are
          available as service modules connected to tourism routes.
        </p>
      </div>
    </section>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="app-shell">
        <header className="header">
          <div className="container top-strip">
            <p>Contact: +91 7829349999</p>
            <p className="top-announcement">Andhra Yatri App Launching Soon - Stay Tuned!</p>
            <div className="social-links" aria-label="Social media links">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
                <svg className="social-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="currentColor" d="M22 12A10 10 0 1 0 10.4 21.9v-7h-2.1V12h2.1V9.8c0-2.1 1.2-3.3 3.2-3.3.9 0 1.8.2 1.8.2v2h-1c-1 0-1.3.6-1.3 1.3V12h2.2l-.4 2.9h-1.8v7A10 10 0 0 0 22 12z"/>
                </svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                <svg className="social-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="currentColor" d="M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2zm-.2 2A3.6 3.6 0 0 0 4 7.6v8.8A3.6 3.6 0 0 0 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6A3.6 3.6 0 0 0 16.4 4H7.6zm9.9 1.5a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2.1a2.9 2.9 0 1 0 0 5.8 2.9 2.9 0 0 0 0-5.8z"/>
                </svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube">
                <svg className="social-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="currentColor" d="M23.5 7.1a3 3 0 0 0-2.1-2.1C19.6 4.5 12 4.5 12 4.5s-7.6 0-9.4.5A3 3 0 0 0 .5 7.1 31.7 31.7 0 0 0 0 12c0 1.7.2 3.3.5 4.9a3 3 0 0 0 2.1 2.1c1.8.5 9.4.5 9.4.5s7.6 0 9.4-.5a3 3 0 0 0 2.1-2.1A31.7 31.7 0 0 0 24 12c0-1.7-.2-3.3-.5-4.9zM9.7 15.5v-7l6.1 3.5-6.1 3.5z"/>
                </svg>
              </a>
              <a href="https://x.com" target="_blank" rel="noreferrer" aria-label="X">
                <svg className="social-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="currentColor" d="M18.9 2H22l-6.8 7.8L23 22h-6.1l-4.8-6.6L6.2 22H3l7.3-8.4L1 2h6.3l4.3 5.9L18.9 2zm-1.1 18h1.7L6.3 3.9H4.5L17.8 20z"/>
                </svg>
              </a>
            </div>
          </div>
          <div className="container header-inner">
            <div className="logo-wrap" aria-label="Andhra Yatri logo">
              <img className="logo-mark" src={`${process.env.PUBLIC_URL}/logo.png`} alt="Andhra Yatri logo" />
            </div>
            <nav className="nav">
              {navPages.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/'}
                  className={({ isActive }) =>
                    isActive ? 'nav-link nav-link-active' : 'nav-link'
                  }
                >
                  {item.title}
                </NavLink>
              ))}
            </nav>
          </div>
        </header>

        <main className="content">
          <div className="container">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/history" element={<InfoPage title="History" {...pageContent.history} />} />
              <Route path="/things-to-do" element={<InfoPage title="Things To Do" {...pageContent.things} />} />
              <Route path="/neighbourhood" element={<InfoPage title="Neighbourhoods" {...pageContent.neighbourhood} />} />
              <Route path="/nighbourhood" element={<Navigate to="/neighbourhood" replace />} />
              <Route path="/travel" element={<InfoPage title="Travel" {...pageContent.travel} />} />
              <Route path="/eat-drink" element={<InfoPage title="Eat & Drink" {...pageContent.eatDrink} />} />
              <Route path="/shopping" element={<InfoPage title="Shopping" {...pageContent.shopping} />} />
              <Route path="/events" element={<InfoPage title="Events" {...pageContent.events} />} />
              <Route path="/contact" element={<InfoPage title="Contact" {...pageContent.contact} />} />
              <Route path="/customer" element={<InfoPage title="Customer" {...pageContent.customer} />} />
              <Route path="/vendor" element={<InfoPage title="Vendor" {...pageContent.vendor} />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </main>

        <footer className="footer">
          <div className="container footer-inner">
            <p><strong>Contact:</strong> +91 7829349999</p>
            <p><strong>Address:</strong> Mangalagiri, Guntur District, Andhra Pradesh 522503</p>
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;

